var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EAF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7397 11.3913C25.5322 11.139 25.2208 11 24.8627 11C24.6696 11 24.4649 11.0401 24.2544 11.119L9.86185 16.5199C9.09659 16.8071 8.99359 17.2395 9.00029 17.4716C9.00697 17.7026 9.13351 18.1253 9.90378 18.3693L12.9561 19.4772L14.5647 23.1241C14.7264 23.6286 15.0643 23.9824 15.4956 24.0972C15.595 24.1237 15.6965 24.1367 15.7988 24.1367C16.149 24.1367 16.5076 23.9839 16.8173 23.6958L18.1501 22.4557L21.4019 24.6725C21.6948 24.8868 22.0134 25 22.3242 25C22.9549 25 23.4579 24.5427 23.6057 23.8351L25.9595 12.5597C26.0563 12.0963 25.9782 11.6813 25.7397 11.3913ZM13.9677 19.306L18.1212 17.1L15.2265 19.7298C15.1234 19.8235 15.066 19.9554 15.0658 20.0928C15.0656 20.0979 15.065 20.1028 15.065 20.1079L15.055 21.771L13.9677 19.306ZM16.1353 22.9767C16.1046 23.0053 16.0738 23.0305 16.0434 23.0523L16.0556 21.0278L17.3104 21.8833L16.1353 22.9767ZM24.984 12.3599L22.6302 23.6353C22.6064 23.7489 22.5291 24.0134 22.3241 24.0134C22.2284 24.0134 22.1096 23.9646 21.9898 23.876C21.9846 23.8721 21.9794 23.8685 21.9741 23.8649L18.3891 21.4209C18.3886 21.4206 18.3881 21.4203 18.3876 21.42L16.3607 20.0382L21.7151 15.1738C21.9001 15.0057 21.9299 14.7275 21.7845 14.5248C21.6392 14.322 21.3642 14.2581 21.143 14.3756L13.2887 18.5472L10.2363 17.4393C10.2341 17.4385 10.2319 17.4377 10.2296 17.4369L24.6074 12.0416C24.7286 11.9961 24.8131 11.9866 24.8627 11.9866C24.8873 11.9866 24.9468 11.9893 24.9673 12.0143C24.9936 12.0463 25.0268 12.1551 24.984 12.3599Z",
    fill: "#2093CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9f96d05dff1b2e3a75ee6ee9bcb8ad10.svg";
export { ForwardRef as ReactComponent };